<template>
    <div>
        <v-dialog v-model="shownRelay" width="400">
            <v-card>
                <div class="primary white--text d-flex align-center">
                    <v-card-title class="py-1 my-1 flex-grow-1">
                        Download Options
                    </v-card-title>
                    <v-btn
                            :disabled="loading"
                            class="mx-2"
                            icon
                            color="white"
                            @click="shownRelay = false"
                            dark
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <div class="pa-2" v-if="!loading">
                    <div class="body-2 font-weight-bold pb-2">
                        Format
                    </div>
                    <div class="d-flex align-center pb-2">
                        <v-btn
                                color="primary"
                                :outlined="downloadFormat !== 'pdf'"
                                @click="downloadFormat = 'pdf'"
                                class="mx-2"
                        >
                            PDF
                        </v-btn>
                        <v-btn
                                color="primary"
                                :outlined="downloadFormat !== 'jpeg'"
                                @click="downloadFormat = 'jpeg'"
                                class="mx-2"
                        >
                            JPEG
                        </v-btn>
                    </div>
                    <div class="body-2 font-weight-bold pb-2 pt-2">
                        Filename <span class="caption grey--text">(NB* clock no only if captured)</span>
                    </div>
                    <div class="d-flex align-center pb-2">
                        <v-btn
                                color="primary"
                                :outlined="downloadFilename !== 'id'"
                                @click="downloadFilename = 'id'"
                                class="mx-2"
                        >
                            ID/Passport No
                        </v-btn>
                        <v-btn
                                color="primary"
                                :outlined="downloadFilename !== 'clock'"
                                @click="downloadFilename = 'clock'"
                                class="mx-2"
                        >
                            Clock No
                        </v-btn>
                    </div>
                    <div class="body-2 font-weight-bold pt-2">
                        Select Images <span class="caption grey--text">(NB* only captured images will download)</span>
                    </div>
                    <div class="pb-2">
                        <v-checkbox
                                v-model="downloadIdentity"
                                label="Identity Document"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadIdentityBack"
                                label="Identity Document Back"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadRecruitment"
                                label="Recruitment Form"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadPhoto"
                                label="Face Photo"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadClock"
                                label="Clock Card"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadBanking"
                                label="Proof of Banking"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                    </div>
                </div>

                <div class="py-2" v-else>
                    <div class="pa-3">
                        <div class="body-1">
                            Downloaded {{this.completedDownloads}} of {{this.recruitments.length}}
                        </div>
                    </div>
                    <v-progress-linear
                            :value="(completedDownloads/this.recruitments.length) * 100"
                    ></v-progress-linear>
                </div>

                <div class="pa-2 d-flex justify-end">
                    <v-btn
                            color="grey"
                            text
                            @click="shownRelay = false"
                            :disabled="loading"
                            class="mx-2"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="downloadStart"
                            :loading="loading"
                            :disabled="loading"
                    >
                        Download
                    </v-btn>
                </div>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {format} from "date-fns";
import axios from "axios";
import {PDFDocument} from 'pdf-lib'
export default {
    props: {
        shown: Boolean,
        recruitments: Array,

    },
    data() {
        return {
            loading: false,
            completedDownloads: 0,
        }
    },
    methods: {

        async downloadImage(url, filename) {
            return this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url}, filename, true, false)
                    .catch(e => {
                        console.log(e)
                        this.$snack.error(`Error downloading ${filename}`)
                    })
        },

        async getURLs(recruitment) {
            const res = await this.$newReq('POST', `recruitment/recruitmentView`, recruitment)
            return {
                recruitmentUrl: res.recruitmentUrl,
                identityUrl: res.identityUrl,
                identityBackUrl: res.identityBackUrl,
                photoUrl: res.photoUrl,
                bankingUrl: res.bankingUrl,
                clockUrl: res.clockUrl,
            }
        },

        async downloadRecruitmentData(recruitment, recruitmentUrl = null, identityUrl = null, identityBackUrl = null, photoUrl = null, bankingUrl = null, clockUrl = null) {
            const identificationStr = recruitment.idNo || recruitment.passportNumber
            const clockStr = recruitment.clockNo || identificationStr
            const downloadPrefix = (this.downloadFilename === 'clock' ? clockStr : identificationStr) || `Recruitment ${format(new Date(recruitment.captured), 'yyyy-MM-dd_HH_mm')}`
            if (this.downloadFormat === 'jpeg') {
                this.loading = true;
                const downloads = []
                if (identityUrl && this.downloadIdentity)
                    downloads.push(this.downloadImage(identityUrl, `${downloadPrefix} Identification.jpeg`));
                if (this.downloadIdentityBack && identityBackUrl)
                    downloads.push(this.downloadImage(identityBackUrl, `${downloadPrefix} Identification Back.jpeg`));
                if (this.downloadRecruitment && recruitmentUrl)
                    downloads.push(this.downloadImage(recruitmentUrl, `${downloadPrefix} Recruitment Form.jpeg`));
                if (this.downloadPhoto && photoUrl)
                    downloads.push(this.downloadImage(photoUrl, `${downloadPrefix}.jpeg`));
                if (this.downloadClock && clockUrl)
                    downloads.push(this.downloadImage(clockUrl, `${downloadPrefix} Clock Card.jpeg`));
                if (this.downloadBanking && bankingUrl)
                    downloads.push(this.downloadImage(bankingUrl, `${downloadPrefix} Proof of Banking.jpeg`));
                await Promise.all(downloads)
                return true
            } else {
                this.loading = true
                const downloads = [];
                if (identityUrl && this.downloadIdentity)
                    downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: identityUrl}, `${downloadPrefix} Identification.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                if (this.downloadIdentityBack && identityBackUrl)
                    downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: identityBackUrl}, `${downloadPrefix} Identification Back.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                if (this.downloadRecruitment && recruitmentUrl)
                    downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: recruitmentUrl}, `${downloadPrefix} Recruitment Form.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                if (this.downloadPhoto && photoUrl)
                    downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: photoUrl}, `${downloadPrefix}.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                if (this.downloadClock && clockUrl)
                    downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: clockUrl}, `${downloadPrefix} Clock Card.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                if (this.downloadBanking && bankingUrl)
                    downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: bankingUrl}, `${downloadPrefix} Proof of Banking.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                const images = await Promise.all(downloads)

                const pdfDoc = await PDFDocument.create()

                for (const images of images) {
                    const jpgImage = await pdfDoc.embedJpg(images)
                    const scaleToFitRatio = 841.89/jpgImage.height
                    const jpgDims = jpgImage.scale(scaleToFitRatio)
                    const page = pdfDoc.addPage([jpgDims.width, jpgDims.height])
                    page.drawImage(jpgImage, {
                        x: 0,
                        y: 0,
                        width: jpgDims.width,
                        height: jpgDims.height,
                    })
                }

                const pdfBytes = await pdfDoc.save()
                const url = window.URL.createObjectURL(new Blob([pdfBytes]));
                const link = document.createElement('a');
                link.href = url;
                link.target = "_blank"
                link.setAttribute('download', `${downloadPrefix}.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();
                return true
            }
        },

        async downloadStart() {

            this.loading = true;
            this.completedDownloads = 0

            for (const recruitment of this.recruitments) {
                try {
                    const {recruitmentUrl, identityUrl, identityBackUrl, photoUrl, bankingUrl, clockUrl} = await this.getURLs(recruitment)
                    const res = await this.downloadRecruitmentData(recruitment, recruitmentUrl, identityUrl, identityBackUrl, photoUrl, bankingUrl, clockUrl)
                } catch (e) {
                    console.log(e)
                    this.$snack.netWorkError()
                } finally {
                    this.completedDownloads = ++this.completedDownloads
                }
            }

            this.loading = false;
        },
    },
    computed: {
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit('update:shown', val)
            }
        },
        downloadFormat: {
            get() {return this.$store.state.downloadImageOptions.format},
            set(val) {this.$store.state.downloadImageOptions.format = val}
        },
        downloadFilename: {
            get() {return this.$store.state.downloadImageOptions.filename},
            set(val) {this.$store.state.downloadImageOptions.filename = val}
        },
        downloadIdentity: {
            get() {return this.$store.state.downloadImageOptions.identity},
            set(val) {this.$store.state.downloadImageOptions.identity = val}
        },
        downloadIdentityBack: {
            get() {return this.$store.state.downloadImageOptions.identityBack},
            set(val) {this.$store.state.downloadImageOptions.identityBack = val}
        },
        downloadRecruitment: {
            get() {return this.$store.state.downloadImageOptions.recruitment},
            set(val) {this.$store.state.downloadImageOptions.recruitment = val}
        },
        downloadPhoto: {
            get() {return this.$store.state.downloadImageOptions.photo},
            set(val) {this.$store.state.downloadImageOptions.photo = val}
        },
        downloadClock: {
            get() {return this.$store.state.downloadImageOptions.clock},
            set(val) {this.$store.state.downloadImageOptions.clock = val}
        },
        downloadBanking: {
            get() {return this.$store.state.downloadImageOptions.banking},
            set(val) {this.$store.state.downloadImageOptions.banking = val}
        },
    },
}
</script>

<style scoped>

</style>